document.addEventListener('DOMContentLoaded', function(){
  var wrap = document.querySelector('.marlo-wrap');
  if (!wrap) return;

  var comment = (wrap.dataset.comment || '').trim();

  var handR = document.getElementById('marloHandR');
  var flipText = wrap.querySelector('.marlo-flip-text');

  var handNormal = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_right_hand.png?v=1765893313';
  var handFlip   = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_right_hand_flip.png?v=1765893314';

  // eyes
  var eyes = document.getElementById('marloEyes');
  var openSrc  = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_eye_nomal.png?v=1765893313';
  var blinkSrc = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_eye_smile.png?v=1765893313';

  // mouth
  var mouth = document.getElementById('marloMouth');
  var smile = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_mouth_smile.png?v=1765893313';
  var open  = 'https://cdn.shopify.com/s/files/1/0703/4807/9257/files/marlo_mouth_open.png?v=1765893313';

  // --- initial flip if comment exists ---
  if (comment){
    wrap.classList.add('is-open');
    if (handR) handR.src = handFlip;
    if (flipText) flipText.textContent = comment;
  } else {
    if (handR) handR.src = handNormal;
  }

  // --- blink ---
  if (eyes){
    function blinkOnce(){
      eyes.src = blinkSrc;
      setTimeout(function(){ eyes.src = openSrc; }, 120);
    }
    setInterval(function(){
      if (Math.random() < 0.35) blinkOnce();
    }, 2800);
  }

  // --- talk (2-5 flaps) ---
  if (mouth){
    var isTalking = false;
    function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
    async function talkBurst(){
      if (isTalking) return;
      isTalking = true;
      var n = 2 + Math.floor(Math.random()*4);
      for (var i=0;i<n;i++){
        mouth.src = open;
        await sleep(120 + Math.floor(Math.random()*60));
        mouth.src = smile;
        await sleep(120 + Math.floor(Math.random()*90));
      }
      await sleep(600 + Math.floor(Math.random()*900));
      isTalking = false;
    }
    setInterval(function(){
      if (Math.random() < 0.30) talkBurst();
    }, 2500);
  }

  // --- admin entrance: top page Marlo double click ---
  var adminWrap = document.querySelector('.marlo-row.is-index .marlo-wrap');

  if (adminWrap) {
    adminWrap.addEventListener('dblclick', function(e){
      e.preventDefault();
      e.stopPropagation();
      openContactAdminWithPrompt();
    });
  }
  
  // --- click: wave + eyes closed + mouth open ---
  wrap.addEventListener('click', function(){
    wrap.classList.remove('marlo-wave');
    void wrap.offsetWidth;
    wrap.classList.add('marlo-wave');

    if (eyes)  eyes.src  = blinkSrc;
    if (mouth) mouth.src = open;

    clearTimeout(window.__MARLO_CLICK_T);
    window.__MARLO_CLICK_T = setTimeout(function(){
      if (eyes)  eyes.src  = openSrc;
      if (mouth) mouth.src = smile;
    }, 900);
  });
});

  // --- admin notice: new contact count ---
  var notice = document.getElementById('marloAdminNotice');
  var noticeCount = document.getElementById('marloAdminNoticeCount');

  function openContactAdminWithPrompt() {
    // 管理画面の認証フローに任せる。秘密の合言葉はURLに付けない。
    window.location.href = 'https://zaccania.net/admin/contact_inquiries.php';
  }

  // 公開ストアから管理者用APIを直接呼ばない。
  // 通知バッジは一時停止。管理画面への入口（マルロのダブルクリック）は維持する。
  if (notice) notice.hidden = true;

  if (notice) {
    notice.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      openContactAdminWithPrompt();
    });
  }
